import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { 
  ASSESSMENT_DOCUMENT_TYPE_LIST,
  ASSESSMENT_DOCUMENT_TYPE_ADD,
  ASSESSMENT_DOCUMENT_TYPE_DETAIL,
  ASSESSMENT_DOCUMENT_TYPE_UPDATE
} from '../../actions';

import {
  AssessmentDocumentTypeListSuccess,
  AssessmentDocumentTypeListError,
  AssessmentDocumentTypeAddSuccess,
  AssessmentDocumentTypeAddError,
  AssessmentDocumentTypeDetailSuccess,
  AssessmentDocumentTypeDetailError,
  AssessmentDocumentTypeUpdateSuccess,
  AssessmentDocumentTypeUpdateError
} from '../../actions';
 
export function* watchAssessmentDocumentTypeList() {
  yield takeEvery(ASSESSMENT_DOCUMENT_TYPE_LIST, onAssessmentDocumentTypeList);
}

export function* watchAssessmentDocumentTypeAdd() {
  yield takeEvery(ASSESSMENT_DOCUMENT_TYPE_ADD, onAssessmentDocumentTypeAdd);
}

export function* watchAssessmentDocumentTypeDetail() {
  yield takeEvery(ASSESSMENT_DOCUMENT_TYPE_DETAIL, onAssessmentDocumentTypeDetail);
}

export function* watchAssessmentDocumentTypeUpdate() {
  yield takeEvery(ASSESSMENT_DOCUMENT_TYPE_UPDATE, onAssessmentDocumentTypeUpdate);
}

const onAssessmentDocumentTypeListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/document_type/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAssessmentDocumentTypeUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/document_type/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAssessmentDocumentTypeAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/document_type/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onAssessmentDocumentTypeDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/document_type/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onAssessmentDocumentTypeList(data) {
  try {
    const response = yield call(onAssessmentDocumentTypeListAsync, data.payload);
    yield put(AssessmentDocumentTypeListSuccess(response.data));
  } catch (error) {
    yield put(AssessmentDocumentTypeListError(error));
  }
}

function* onAssessmentDocumentTypeAdd(data) {
  try {
      const response = yield call(onAssessmentDocumentTypeAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AssessmentDocumentTypeAddSuccess(response.data));
  } catch (error) {
      yield put(AssessmentDocumentTypeAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onAssessmentDocumentTypeDetail(data) {
  try {
    const response = yield call(onAssessmentDocumentTypeDetailAsync, data.payload);
    yield put(AssessmentDocumentTypeDetailSuccess(response.data.data));
  } catch (error) {
    yield put(AssessmentDocumentTypeDetailError(error));
  }
}

function* onAssessmentDocumentTypeUpdate(data) {
  try {
      const response = yield call(onAssessmentDocumentTypeUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AssessmentDocumentTypeUpdateSuccess(response.data));
  } catch (error) {
      yield put(AssessmentDocumentTypeUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchAssessmentDocumentTypeList),
    fork(watchAssessmentDocumentTypeAdd),
    fork(watchAssessmentDocumentTypeDetail),
    fork(watchAssessmentDocumentTypeUpdate),
  ]);
} 